import Axios from 'axios';
import { protectedResources } from '../authConfig';

const URL =
  protectedResources.apiHRMobile.baseApi +
  '/api/v1/backoffice/GetAdvanceSalaryNotification';
let tokenKey;

export async function getBadgeCount(month = 2022, year = 9) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  const bodyParameters = {
    year: 2022,
    month: 9,
  };

  try {
    const response = await Axios.post(URL, bodyParameters, config);
    return await response.data;
  } catch (error) {
    console.error(error);
  }
}
